import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const AcceptIcon = (properties: iconType) => (
  <SvgIcon
    {...properties}
    viewBox="0 0 11 9"
    style={{ fill: 'none', width: '11px', height: '9', stroke: '#78869E' }}
  >
    <path d="M1 3.92767L4.07606 7.22222L9.88889 1" />
  </SvgIcon>
);

AcceptIcon.defaultProperties = {
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  stroke: '#78869E',
  strokeWidth: '2',
};

export default AcceptIcon;
